import React from 'react';
import { styled } from '@stitches/react';
import { blackA } from '@radix-ui/colors';
import * as SwitchPrimitive from '@radix-ui/react-switch';

interface SwitchToggleProps {
  isCheck?: boolean
  onChange?: any
  actionElse?: any
  color?: string,
  white?: boolean
}

export const SwitchToggle: React.FC<SwitchToggleProps> = ({ onChange, isCheck, actionElse, color, white }) => {
  const StyledSwitch = styled(SwitchPrimitive.Root, {
    all: 'unset',
    width: 34,
    height: 15,
    display:'flex' ,
    alignItems:'center',
    backgroundColor:` ${white  ? '#FFFFFF': '#E7E7E7'  }`,
    borderRadius: '9999px',
    position: 'relative',
    cursor:'pointer',
    // boxShadow: `0 2px 10px ${blackA.blackA7}`,
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
    // '&:focus': { boxShadow: `0 0 0 2px black` },
    '&[data-state="checked"]': { backgroundColor: `${color}` },
    '&:hover':{ backgroundColor: `${color}` },
  });

  const StyledThumb = styled(SwitchPrimitive.Thumb, {
    display: 'block',
    width: 17,
    height: 17,
    border:' 1px solid #C4C3C3',
    backgroundColor: 'white',
    borderRadius: '9999px',
    boxShadow: `0 2px 2px ${blackA.blackA7}`,
    transition: 'transform 100ms',
    transform: 'translateX(2px)',
    willChange: 'transform',
    marginLeft:'-2px',
    '&[data-state="checked"]': { transform: 'translateX(19px)' },
  });

  const Switch = StyledSwitch;
  const SwitchThumb = StyledThumb;
  return (
    <Switch checked={isCheck} onCheckedChange={(bool) => {
      if (bool) {
        onChange()
      } else {
        actionElse()
      }
    }} id="s1">
      <SwitchThumb />
    </Switch>
  )

}
